import { PORTFOLIO_DATA } from './shared/data.js';
import { renderNav, initNavigation } from './shared/navigation.js';
import { renderProjectCard } from './shared/utils.js';
import './style.css';

// The landing page is a hub: short intro (hero) + a few featured projects +
// contact. The full intro lives on about.html, all projects on projects/.
document.addEventListener('DOMContentLoaded', () => {
  renderNav();
  initNavigation();

  // Currently shipping — the active project highlight.
  const active = document.getElementById('activeContent');
  if (active) {
    const c = PORTFOLIO_DATA.currentProject;
    const subtitle = c.description.split('. ').slice(0, 1).join('. ') + '.';
    active.innerHTML = `
      <div>
        <div class="active-title">${c.title}</div>
        <div class="active-sub">${subtitle}</div>
        <div class="active-tags">${c.tags.map(t => `<span class="active-tag">${t}</span>`).join('')}</div>
        <a class="active-gh" href="${c.github}" target="_blank" rel="noopener">VIEW ON GITHUB ↗</a>
      </div>
      <div class="active-bullets">
        ${c.highlights.map(b => `<div class="active-bullet">${b}</div>`).join('')}
      </div>
    `;
  }

  const grid = document.getElementById('projectGrid');
  if (grid) {
    const featured = PORTFOLIO_DATA.projects
      .filter(p => p.featured)
      .sort((a, b) => (b.year ?? 0) - (a.year ?? 0));
    grid.innerHTML = featured.map(p => renderProjectCard(p, 'projects/')).join('');
  }

  // Smooth scroll for in-page anchors (#top, #contact).
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = 70;
        const pos = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: pos, behavior: 'smooth' });
      }
    });
  });
});
